// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"398":"abcb40f9","493":"f5535314","606":"c6114a68"}[chunkId] + ".chunk.js";
};